import Utils from '@/core/utils/utils'
import EmpresaUtils from '@/core/utils/empresa-utils'
import EmpresaAPI from '@/api/empresa-api'
import Constants from '@/core/constants/constants'
import Vue from 'vue'

const Geral = {
  state: () => ({
    cadernoLateral: {
      status: false,
      anotacao: ''
    },
    exibicaoCursosCategoria: null,
    exibicaoCursosDisciplina: null,
    exibicaoCursoDetalhe: null,
    menuCurso: false,
    autoplay: false,
    controleTopico: '',
    segundos: 0,
    timer: false,
    modoNoturno: false,
    nomeCurso: '',
    empresa: null,
    ferramentaNome: null,
    ferramentaAtiva: null
  }),

  getters: {
    exibicaoCursosCategoria: state => {
      return state.exibicaoCursosCategoria
    },
    exibicaoCursosDisciplina: state => {
      return state.exibicaoCursosDisciplina
    },
    exibicaoCursoDetalhe: state => {
      return state.exibicaoCursoDetalhe
    },
    caderno_lateral: state => {
      return state.cadernoLateral
    },
    getAutoplay: state => {
      return state.autoplay
    },
    getControleTopico: state => {
      return state.controleTopico
    },
    getModoNoturno: state => {
      return state.modoNoturno
    },
    getMenuCursoState: state => {
      return state.menuCurso
    },
    empresa: state => {
      return state.empresa
    },
    getFerramentaNome: state => {
      return state.ferramentaNome
    },
    getFerramentaAtiva: state => {
      return state.ferramentaAtiva
    }
  },

  mutations: {
    alternaCadernoLateral (state, anotacao) {
      state.cadernoLateral.status = !state.cadernoLateral.status
      state.cadernoLateral.anotacao = anotacao
    },
    setAutoplay (state, autoplay) {
      state.autoplay = autoplay
    },
    resetCadernoLateral (state) {
      state.cadernoLateral = {
        status: false,
        anotacao: ''
      }
    },
    exibicaoCursosCategoria (state, exibicaoCursosCategoria) {
      state.exibicaoCursosCategoria = exibicaoCursosCategoria
    },
    exibicaoCursosDisciplina (state, exibicaoCursosDisciplina) {
      state.exibicaoCursosDisciplina = exibicaoCursosDisciplina
    },
    exibicaoCursoDetalhe (state, exibicaoCursoDetalhe) {
      state.exibicaoCursoDetalhe = exibicaoCursoDetalhe
    },
    setControleTopico (state, controleTopico) {
      state.controleTopico = controleTopico
    },
    setSegundos (state, segundos) {
      state.segundos = segundos
    },
    setTimer (state, timer) {
      state.timer = timer
    },
    setModoNoturno (state, modoNoturno) {
      state.modoNoturno = modoNoturno
    },
    setNomeCurso (state, nomeCurso) {
      state.nomeCurso = nomeCurso
    },
    alternaMenuCurso (state) {
      state.menuCurso = !state.menuCurso
    },
    setMenuCurso (state, menuCurso) {
      state.menuCurso = menuCurso
    },
    setEmpresa (state, config) {
      if (!config.homeVersion) {
        config.homeVersion = Constants.HOME_VERSION_DEFAULT
      }
      if (!config.headerVersion) {
        config.headerVersion = Constants.HEADER_VERSION_DEFAULT
      }
      Vue.prototype.$configEmpresa = config
      state.empresa = config
    },
    setFerramenta (state, ferramenta) {
      switch (ferramenta) {
        case 'modelos-3d':
          state.ferramentaNome = 'Modelos 3D'
          state.ferramentaAtiva = 'modelos-3d'
          break
        case 'mapas-mentais':
          state.ferramentaNome = 'Mapas Mentais'
          state.ferramentaAtiva = 'mapas-mentais'
          break
        case 'resumos':
          state.ferramentaNome = 'Resumos'
          state.ferramentaAtiva = 'resumos'
          break
        case 'todas':
          state.ferramentaNome = null
          state.ferramentaAtiva = null
          break
      }
    }
  },

  actions: {
    async alternaCadernoLateral ({ commit }, anotacao) {
      commit('alternaCadernoLateral', anotacao)
    },
    async resetCadernoLateral ({ commit }) {
      commit('resetCadernoLateral')
    },
    exibicaoCursosCategoria ({ commit }, exibicaoCursosCategoria) {
      commit('exibicaoCursosCategoria', exibicaoCursosCategoria)
    },
    exibicaoCursosDisciplina ({ commit }, exibicaoCursosDisciplina) {
      commit('exibicaoCursosDisciplina', exibicaoCursosDisciplina)
    },
    exibicaoCursoDetalhe ({ commit }, exibicaoCursoDetalhe) {
      commit('exibicaoCursoDetalhe', exibicaoCursoDetalhe)
    },
    alternaAutoplay ({ commit }, autoplay) {
      commit('setAutoplay', autoplay)
    },
    defineControleTopico ({ commit }, controleTopico) {
      commit('setControleTopico', controleTopico)
    },
    async iniciaTimer ({ commit }, segundos) {
      commit('setSegundos', segundos)
      commit('setTimer', true)
      for (let i = segundos; i >= 0; i--) {
        await Utils.sleep(1000)
        commit('setSegundos', i)
      }
      commit('setTimer', false)
    },
    alternaModoNoturno ({ commit }, modoNoturno) {
      commit('setModoNoturno', modoNoturno)
    },
    defineNomeCurso ({ commit }, nomeCurso) {
      commit('setNomeCurso', nomeCurso)
    },
    alternaMenuCurso ({ commit }) {
      commit('alternaMenuCurso')
    },
    menuCurso ({ commit }, menuCurso) {
      commit('setMenuCurso', menuCurso)
    },
    async empresa ({ commit }) {
      const config = await EmpresaAPI.pegaConfiguracaoWL(EmpresaUtils.pegaReferenciaEmpresa())
      commit('setEmpresa', config)
    },
    alternaFerramenta ({ commit }, ferramenta) {
      commit('setFerramenta', ferramenta)
    }
  }
}

export default Geral
